import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Gallery',
    href: '/gallery'
  }, {
    name: 'Testimonials',
    href: '/testimonials'
  }, {
    name: 'Contact Us',
    href: '/booking'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || location.pathname !== '/' ? 'bg-jet/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="flex justify-between items-center" data-id="element-200">
          {/* Logo */}
          <Link to="/" className="flex items-center group" data-id="element-201">
            <div className="flex flex-col leading-tight" data-id="element-202">
              <span className="font-heading text-2xl md:text-3xl font-bold text-burgundy tracking-wide group-hover:text-brown transition-colors" data-id="element-203">
                Beni's
              </span>
              <span className="text-[0.6rem] md:text-xs uppercase tracking-[0.25em] text-cream/80 font-medium -mt-0.5" data-id="element-204">
                African Hair Braiding
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-205">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`text-sm uppercase tracking-wider font-medium transition-colors ${location.pathname === link.href ? 'text-burgundy' : 'text-cream hover:text-brown'}`} data-id="element-206">
                {link.name}
              </Link>)}
            <Button variant="primary" size="sm" onClick={() => navigate('/booking')} data-id="element-207">
              Book Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-burgundy hover:text-brown transition-colors p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-208">
            {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-209" /> : <MenuIcon className="h-6 w-6" data-id="element-210" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-211">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-jet border-t border-brown/30 overflow-hidden" data-id="element-212">
            <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-213">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`block px-3 py-4 font-medium text-lg border-b border-brown/20 ${location.pathname === link.href ? 'text-burgundy bg-burgundy/10' : 'text-cream hover:text-brown hover:bg-brown/20'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-214">
                  {link.name}
                </Link>)}
              <div className="pt-6 px-3" data-id="element-215">
                <Button variant="primary" className="w-full" onClick={() => {
              setIsMobileMenuOpen(false);
              navigate('/booking');
            }} data-id="element-216">
                  Book Appointment
                </Button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}